import moment from "moment";
import { LicensedNFTStatus } from "../constant/CommonConstant";

export const delayAsync = (ms: number) => new Promise<void>(resolve => setTimeout(() => resolve(), ms));

export const formatTime = (time: string): number => {
    return moment(time, "yyyy-MM-DD HH:mm:ss").valueOf() / 1000;
};

export const getCurrentUtc = (): number => {
    let d1 = new Date();
    let d2 = new Date(d1.getUTCFullYear(), d1.getUTCMonth(), d1.getUTCDate(), d1.getUTCHours(), d1.getUTCMinutes(), d1.getUTCSeconds());
    return d2.getTime();
};

export const finneyToEth = (finney: number) => {
    return finney / 1000;
};

export const handleLicensedText = (status: LicensedNFTStatus, text?: string) => {
    if (status === LicensedNFTStatus.UNLICENSED || !text) {
        return "N/A";
    }
    return text;
};

export const handleNFTName = (collectionName: string, tokenId: string) => {
    return `${collectionName} #${tokenId}`;
};

export const toOpensea = (account: string) => {
    window.open('https://testnets.opensea.io/' + account)
}

export function getQueryString(param:string) {
    const reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)');
    const r = window.location.search.substring(1).match(reg) || window.location.hash.substring((window.location.hash.search("/?/")) + 1).match(reg);
    if(r){
        return decodeURIComponent(r[2]);
    }
    return "";
}

